import { CSSProperties } from 'react';

//Estilos modal confirmación carga masiva de pacientes
export const modalPatientMassUploadConfirmationConfig = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '12px',
        padding: '25px 50px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    },
};

export const spinnerPatientStyles: CSSProperties = {
    display: 'block',
    margin: '40px auto',
};
